import { dimensions } from './variables'

export const getEmSize = (size: number) => size / dimensions.fontSize.regular
